import React from 'react';
import { LDProvider } from 'launchdarkly-react-client-sdk';
import useLaunchDarkly from '#shared/hooks/useLaunchDarklyContext';
import { LD_CONTEXT_KIND_VALUE } from '#shared/constants/common';
import ContainerTypeSelect from '#shared/components/ContainerTypeSelect/ContainerTypeSelect';
const ContainerTypeField = ({
  disabled,
  error,
  hint,
  labelAction,
  name,
  onChange,
  required,
  value
}) => {
  const {
    ldClientId,
    environment,
    userKey,
    userId
  } = useLaunchDarkly();
  if (!ldClientId) {
    return null;
  }
  return /*#__PURE__*/React.createElement(LDProvider, {
    clientSideID: ldClientId,
    context: {
      kind: LD_CONTEXT_KIND_VALUE,
      key: userKey,
      environment: environment,
      userId: userId
    }
  }, /*#__PURE__*/React.createElement(ContainerTypeSelect, {
    disabled: disabled,
    error: error,
    hint: hint,
    labelAction: labelAction,
    name: name,
    onChange: nextValue => onChange({
      target: {
        name,
        value: nextValue,
        type: 'select'
      }
    }),
    required: required,
    value: value
  }));
};
export default ContainerTypeField;